module.exports = __webpack_public_path__ + "img/sleeve_cap_rise.8756e51e.png";